// PASS 2 (B6) — the same GSTIN rule the server enforces, so the form can say what is wrong
// while it is being typed. The server remains the authority (backend/gstin_rules.py).
export const GST_STATE_CODES = {
  "01": "Jammu & Kashmir", "02": "Himachal Pradesh", "03": "Punjab", "04": "Chandigarh",
  "05": "Uttarakhand", "06": "Haryana", "07": "Delhi", "08": "Rajasthan", "09": "Uttar Pradesh",
  "10": "Bihar", "11": "Sikkim", "12": "Arunachal Pradesh", "13": "Nagaland", "14": "Manipur",
  "15": "Mizoram", "16": "Tripura", "17": "Meghalaya", "18": "Assam", "19": "West Bengal",
  "20": "Jharkhand", "21": "Odisha", "22": "Chhattisgarh", "23": "Madhya Pradesh", "24": "Gujarat",
  "26": "Dadra & Nagar Haveli", "27": "Maharashtra", "28": "Andhra Pradesh", "29": "Karnataka",
  "30": "Goa", "31": "Lakshadweep", "32": "Kerala", "33": "Tamil Nadu", "34": "Puducherry",
  "35": "Andaman & Nicobar", "36": "Telangana", "37": "Andhra Pradesh (New)", "38": "Ladakh",
  "97": "Other Territory", "99": "Centre Jurisdiction",
};

const ALIASES = {
  "jammu and kashmir": ["01"], "jammu & kashmir": ["01"],
  "andhra pradesh": ["28", "37"],
  "dadra and nagar haveli": ["26"], "dadra & nagar haveli": ["26"],
  "dadra and nagar haveli and daman and diu": ["26"],
  "andaman and nicobar islands": ["35"], "andaman & nicobar": ["35"],
  "pondicherry": ["34"], "puducherry": ["34"], "orissa": ["21"], "odisha": ["21"],
  "uttaranchal": ["05"], "uttarakhand": ["05"], "delhi": ["07"], "new delhi": ["07"],
};

const CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const SHAPE = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

export const normaliseGstin = (v) => String(v || "").replace(/[\s-]/g, "").toUpperCase();

export function checkDigit(first14) {
  let sum = 0;
  for (let i = 0; i < first14.length; i++) {
    const product = CHARSET.indexOf(first14[i]) * (i % 2 === 0 ? 1 : 2);
    sum += Math.floor(product / 36) + (product % 36);
  }
  return CHARSET[(36 - (sum % 36)) % 36];
}

function codesForState(state) {
  const s = String(state || "").trim().toLowerCase();
  if (!s) return [];
  if (ALIASES[s]) return ALIASES[s];
  return Object.entries(GST_STATE_CODES).filter(([, n]) => n.toLowerCase() === s).map(([c]) => c);
}

export function checkGstin(value, state = "") {
  const gstin = normaliseGstin(value);
  if (!gstin) return { valid: false, gstin, error: "GST Number is required" };
  if (gstin.length !== 15) return { valid: false, gstin, error: `GSTIN must be 15 characters — this one has ${gstin.length}` };
  if (!SHAPE.test(gstin)) return { valid: false, gstin, error: "GSTIN format is wrong — it must read 2 digits, then PAN (AAAAA9999A), then 1 character, then Z, then the check character" };
  const code = gstin.slice(0, 2);
  const stateName = GST_STATE_CODES[code];
  if (!stateName) return { valid: false, gstin, error: `${code} is not a GST state code` };
  // PART C: never reveal the correct last character (same wording as gstin_rules.py)
  if (gstin[14] !== checkDigit(gstin.slice(0, 14))) return { valid: false, gstin, stateFromGstin: stateName, error: "This GST number has a typing mistake. Please check it against the GST certificate." };
  if (state) {
    const allowed = codesForState(state);
    if (allowed.length && !allowed.includes(code)) {
      return { valid: false, gstin, stateFromGstin: stateName, error: `GSTIN starts with ${code} (${stateName}) but the state is ${state}` };
    }
  }
  return { valid: true, gstin, stateFromGstin: stateName, error: "" };
}
